import { Geolocation } from '@capacitor/geolocation'

export default {
    namespaced: true,
    state: () => {
        return {
            live: {
                longitude: undefined,
                latitude: undefined,
                timestamp: undefined,
            },
        }
    },
    mutations: {
        start(state, { watchId }) {
            state.watchId = watchId
        },

        SET_DATA({ live }, { coords, timestamp }) {
            live.latitude = coords.latitude
            live.longitude = coords.longitude
            live.timestamp = timestamp
        },

        stop(state) {
            if (state.watchId) {
                Geolocation.clearWatch({ id: state.watchId })
            }
            state.live.latitude = undefined
            state.live.longitude = undefined
            state.live.timestamp = undefined
        },
    },

    getters: {
        longitude({ live }) {
            return live.longitude
        },
        latitude({ live }) {
            return live.latitude
        },
        isGPSLive({ live }) {
            return live.timestamp !== undefined
        },
    },

    actions: {
        async start({ commit }) {
            try {
                // Vérifie permissions
                let perm = await Geolocation.checkPermissions()
                console.log('permissions', perm)

                const noFine = perm.location !== 'granted' && perm.location !== 'grantedAlways'
                const noCoarse = perm.coarseLocation !== 'granted'

                if (noFine && noCoarse) {
                    await Geolocation.requestPermissions()
                    perm = await Geolocation.checkPermissions()

                    const stillNoFine = perm.location !== 'granted' && perm.location !== 'grantedAlways'
                    const stillNoCoarse = perm.coarseLocation !== 'granted'

                    if (stillNoFine && stillNoCoarse) {
                        throw new Error('Location permission denied')
                    }
                }

                // Démarre la surveillance de position
                const watchId = await Geolocation.watchPosition(
                    { enableHighAccuracy: true, timeout: 10000, maximumAge: 5000 },
                    (position, err) => {
                        if (err) {
                            console.log('Geolocation failed', err)
                            return
                        }
                        if (position) {
                            commit('SET_DATA', position)
                        }
                    }
                )

                commit('start', { watchId })
            } catch (error) {
                console.log('WTF', error)
            }
        },

        async stop({ commit }) {
            commit('stop')
        },
    },
}
